// extracted by mini-css-extract-plugin
export default {"sbCloseIcon":"FpAFAwp","asosNameIcon":"teaIS_G"};